export interface ActivitySubjectRouteIdentity {
  subjectId?: string | null;
  subjectKey?: string | null;
  subjectLabel?: string | null;
}

const MAX_SUBJECT_ROUTE_ID_LENGTH = 120;
const DOMINO_SUBJECT_UUID_PATTERN =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

const normalizeText = (value: string | null | undefined): string =>
  typeof value === 'string' ? value.trim() : '';

export const slugifyActivitySubjectRoutePart = (value: string): string =>
  value
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, MAX_SUBJECT_ROUTE_ID_LENGTH);

export const normalizeActivitySubjectRouteId = (
  value: string | null | undefined
): string => slugifyActivitySubjectRoutePart(normalizeText(value));

export const isActivitySubjectUuid = (
  value: string | null | undefined
): boolean => DOMINO_SUBJECT_UUID_PATTERN.test(normalizeText(value));

const extractSubjectKeyId = (subjectKey: string): string | null => {
  const parts = subjectKey
    .split(':')
    .map((part) => part.trim())
    .filter(Boolean);
  const lastPart = parts[parts.length - 1];
  if (!lastPart) return null;

  const routeId = normalizeActivitySubjectRouteId(lastPart);
  return routeId || null;
};

export const buildActivitySubjectRouteId = (
  subject: ActivitySubjectRouteIdentity
): string => {
  const explicitId = normalizeActivitySubjectRouteId(subject.subjectId);
  if (explicitId) return explicitId;

  const subjectKey = normalizeText(subject.subjectKey);
  if (subjectKey) {
    const keyId = extractSubjectKeyId(subjectKey);
    if (keyId) return keyId;
  }

  const labelId = normalizeActivitySubjectRouteId(subject.subjectLabel);
  return labelId || 'unknown';
};
